<ng-container *ngIf="!this.isRefreshAvialable()">

    <div class="layout-wrapper" (click)="onLayoutClick()" [ngClass]="{'layout-wrapper-overlay-sidebar': isOverlay(),
    'layout-wrapper-slim-sidebar': isSlim(),
                 'layout-wrapper-horizontal-sidebar': isHorizontal(),
                 'layout-wrapper-overlay-sidebar-active': overlayMenuActive,
                 'layout-wrapper-sidebar-inactive': staticMenuDesktopInactive,
                 'layout-wrapper-sidebar-mobile-active': staticMenuMobileActive}">
        <app-topbar></app-topbar>

        <!-- <app-megamenu></app-megamenu> -->

        <div class="layout-sidebar" (click)="onMenuClick($event)" [ngClass]="{'layout-sidebar-dark': menuMode !== 'light',
         'layout-sidebar-gradient':  menuMode === 'gradient'}">
            <div class="user-profile" style="text-align:center">
                <a [routerLink]="['edit-data']" id="sidebar-profile-button">
                    <span class="sidebar-profile-name">Welcome!</span>
                    <img [src]="user?.avatar_url==null 
                || (user.avatar_url==null || user.avatar_url.length=='0')
                ?'assets/images/avatar.png':user.avatar_url"
                        style="border-radius: 50%;margin-left:auto;margin-right:auto;" class="avatar-image"
                        alt="patient_profile" />
                    <span class="sidebar-profile-name notranslate">{{name | titlecase}}</span>
                </a>
            </div>
            <div class="sidebar-scroll-content">
                <!-- <app-inline-profile *ngIf="profileMode=='inline' && !isHorizontal()"></app-inline-profile> -->
                <app-menu></app-menu>
            </div>
        </div>

        <!-- <app-rightpanel></app-rightpanel> -->
        <div class="layout-main breadcrumb-bar">
            <app-breadcrumb></app-breadcrumb>
            <div class="layout-main-content">
                <router-outlet></router-outlet>
            </div>

            <!-- <app-footer></app-footer> -->
        </div>
    </div>

</ng-container>

<ng-container *ngIf="this.isRefreshAvialable()">
    <app-loading class="ui-g-12 text-center" type='LOADING_DATA'></app-loading>
</ng-container>